import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/Button';
import { LogOut } from 'lucide-react';
import { useStore } from '../../store/useStore';
import { supabase } from '../../config/supabase';
import toast from 'react-hot-toast';

export const SignOutButton: React.FC = () => {
  const navigate = useNavigate();
  const { setUser, clearAuth } = useStore();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleSignOut = async () => {
    try {
      setIsLoading(true);

      // Sign out from Supabase
      const { error } = await supabase.auth.signOut();
      if (error) throw error;

      // Clear all auth state
      setUser(null);
      clearAuth?.(); // Optional chaining in case clearAuth isn't defined

      // Clear all localStorage items
      localStorage.clear();

      // Clear any session cookies
      document.cookie.split(';').forEach(cookie => {
        document.cookie = cookie
          .replace(/^ +/, '')
          .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
      });

      // Show success message
      toast.success('Signed out successfully');

      // Force reload to clear any remaining state
      window.location.href = '/signin';
    } catch (error) {
      console.error('Sign out error:', error);
      toast.error('Failed to sign out');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleSignOut}
      icon={<LogOut className="w-4 h-4" />}
      loading={isLoading}
      disabled={isLoading}
    >
      Sign Out
    </Button>
  );
};